import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix NGN icon. Exported from Figma (Bombiix 2026). */
const NGNIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path d="M6.66699 15.3327V5.33268H7.00033L13.0003 14.666H13.3337V4.66602M4.66699 8.66602H15.3337M4.66699 11.3327H15.3337" stroke="currentColor" />
  </svg>
);

export default NGNIcon;
